import { computed, getCurrentInstance, unref } from 'vue';
import {
    useGetters,
    useState,
    useActions,
} from 'vuex-composition-helpers';
import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';
import { type IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
import { IMapForSearchDataGetters, IMapForSearchDataState } from '@ve/pages/serp/store';
import { NAMESPACE as MAP_FOR_SEARCH_DATA } from '@ve/pages/serp/store/SearchDataStore';
import { initFilterBudgetBackboneVuex } from '@features/filterByBudget';
import { filterTourProductsByHotels } from '@features/tourProduct/filterTourProducts';
import { useSearchTourProducts } from '@features/tourProduct/searchTourProducts';
import { groupTourProductsByHotel, getUniqHotelsFromGroup } from '@entities/tourProduct';
import initConnectionBackboneVuex from './initConnectionBackboneVuex';

export default function () {
    initFilterBudgetBackboneVuex();
    initConnectionBackboneVuex();
    const proxy = getCurrentInstance()?.proxy;
    const {
        searchedTourProducts,
    } = useSearchTourProducts();
    const {
        syncHotels,
        isPopularityFilterActive,
        filteredHotelsWithoutOperator,
        filteredHotelsWithoutRestType: filteredHotelsWithoutRestTypeBackbone,
        filteredHotels: filteredHotelsBackbone,
        filteredHotelsWithoutPrice: filteredHotelsWithoutPriceBackbone,
        filteredHotelsWithoutBeachType: filteredHotelsWithoutBeachTypeBacbkone,
        filteredHotelsWithoutRenovations,
    } = useState<IMapForFiltersSerpState>(nameFilterSerpStore,
        [
            'syncHotels',
            'isPopularityFilterActive',
            'filteredHotelsWithoutOperator',
            'filteredHotels',
            'filteredHotelsWithoutRestType',
            'filteredHotelsWithoutPrice',
            'filteredHotelsWithoutBeachType',
            'filteredHotelsWithoutRenovations',
        ]);

    const { touristGroup } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['touristGroup']);

    const groupedTourProductsWithoutOperators = computed(() => {
        const filteredTourProductsWithoutOperatorsByHotels = filterTourProductsByHotels(unref(searchedTourProducts), unref(filteredHotelsWithoutOperator));
        return groupTourProductsByHotel(filteredTourProductsWithoutOperatorsByHotels);
    });

    const groupedFilteredTourProducts = computed(() => {
        const filteredTourProductsByHotels = filterTourProductsByHotels(unref(searchedTourProducts), unref(filteredHotelsBackbone));
        return groupTourProductsByHotel(filteredTourProductsByHotels);
    });
    const filteredHotelsWithoutRestType = computed(() => {
        const filteredTourProductsWithoutRestType = filterTourProductsByHotels(unref(searchedTourProducts), unref(filteredHotelsWithoutRestTypeBackbone));
        const groupedTourProducts = groupTourProductsByHotel(filteredTourProductsWithoutRestType);
        return getUniqHotelsFromGroup(groupedTourProducts);
    });

    const filteredHotelsWithoutBeachType = computed(() => {
        const filteredTourProductsWithoutRestType = filterTourProductsByHotels(unref(searchedTourProducts), unref(filteredHotelsWithoutBeachTypeBacbkone));
        const groupedTourProducts = groupTourProductsByHotel(filteredTourProductsWithoutRestType);
        return getUniqHotelsFromGroup(groupedTourProducts);
    })

    const tourProductsPrices = computed(() => {
        return unref(filteredHotelsWithoutPriceBackbone).map((hotel) => hotel.minPrice);
    });

    const groupedAllTourProducts = computed(() => groupTourProductsByHotel(unref(searchedTourProducts)));
    const filteredHotels = computed(() => getUniqHotelsFromGroup(unref(groupedFilteredTourProducts)));
    const allHotels = computed(() => getUniqHotelsFromGroup(unref(groupedAllTourProducts)));

    const { directFlight, block } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['directFlight', 'block']);

    const {
        searchCountries,
        searchDepartureCity,
    } = useState<IMapForSearchDataState>(MAP_FOR_SEARCH_DATA, ['searchCountries', 'searchDepartureCity'])

    const {
        isPairOfDepartureCityAndArrivalCountryAreValid,
    } = useGetters<IMapForSearchDataGetters>(MAP_FOR_SEARCH_DATA, ['isPairOfDepartureCityAndArrivalCountryAreValid']);


    const directFlightModel = computed({
        get: () => directFlight.value,
        set: (value) => {
            proxy?.$root.$emit('start-search-by-direct-flight-filter', value);
        }
    })

    const blockModel = computed({
        get: () => block.value,
        set: (value) => {
            proxy?.$root.$emit('block-changed', value);
        }
    })

    return {
        directFlightModel,
        touristGroup,
        groupedAllTourProducts,
        groupedTourProductsWithoutOperators,
        filteredHotelsWithoutRestType,
        filteredHotelsWithoutBeachType,
        filteredHotelsWithoutRenovations,
        filteredHotels,
        allHotels,
        groupedFilteredTourProducts,
        tourProductsPrices,
        isPopularityFilterActive,
        searchCountries,
        searchDepartureCity,
        blockModel,
        isPairOfDepartureCityAndArrivalCountryAreValid,
    };
}